import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_COMPONENT_TREE_LIST = 'FETCH_COMPONENT_TREE_LIST'
export const RECEIVE_COMPONENT_TREE_LIST = 'RECEIVE_COMPONENT_TREE_LIST'
export const FAILED_COMPONENT_TREE_LIST = 'FAILED_COMPONENT_TREE_LIST'

export function fetchComponentTreeList(_data){
    if(_data == undefined){
        _data = {
            status: 1
        }
    }
    return (dispatch, getState) => {
        dispatch({type: FETCH_COMPONENT_TREE_LIST})
        axios({
            method: 'POST',
            url: API_LINKS.COMPONENT_TREE_LIST_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_COMPONENT_TREE_LIST,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_COMPONENT_TREE_LIST
                    })
                }
            } else {
                dispatch({
                    type: FAILED_COMPONENT_TREE_LIST
                })
            }
        })
        .catch(function(error){
            if(error.response){
                dispatch({type: FAILED_COMPONENT_TREE_LIST})
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/components/aComponents-ComponentTreeList.jsx